
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import Check from "@material-ui/icons/Check";

import Checkbox from "@material-ui/core/Checkbox";

//Styles
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";



class CheckboxClass extends React.Component{
    render(){
        const {...rest} = this.props.props
        const classes=this.props.classes;
        return <Checkbox
            style={{width:30}}
            className={classes.positionAbsolute}
            tabIndex={-1}
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked
            }}
            {...rest}
          />;
    }
}
export default withStyles(extendedTablesStyle)(CheckboxClass);


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.jsx